import Vue from 'vue';
import VueRouter from 'vue-router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import '@/assets/design/css/custom-nprogress.css';
import store from '@/store';

Vue.use(VueRouter);

import AuthRoutes from './auth.routes';
import DashboardRoutes from './dashboard.routes';
import AchatRoutes from './achat';
import GmaoRoutes from './gmao';
import GpaoRoutes from './gpao';
import GpaoTacheRoutes from './gpao_tache';
import ConfigurationRoutes from './configuration';
import CrmRoutes from './crm';
import AgendaRoutes from './agenda';
import RhRoutes from './rh';
import CompteRoutes from './compte';

/*
import TiersRoute from './tiers';
import ArticleStockRoute from './article_stock';
import CatalogueRoute from './catalogue';
import ExpressionBesoinRoute from './expression-besoin-routes';
import CollectePrixRoute from './collecte_prix';
import AppelOffreRoute from './appel_offre';
import ContratRoute from './contrat-routes';
import DemandeAchatRoute from './demande-achat-routes';
import CommandeRoute from './commande-routes';
import FactureRoute from './facture-routes';
import ReceptionRoute from './reception-routes';
import PlanningBudgetaireRoute from './planning-budgetaire-routes';
import AbonnementRoute from './abonnement';
import NoteFraisRoute from './note_frais';
import ChatRoute from './chat-routes';
import Paiement from './paiement';*/

//import ConfigurationRoutes from './configuration';

const routes = [
  ...AuthRoutes,
  ...DashboardRoutes,
  ...AchatRoutes,
  ...GmaoRoutes,
  ...GpaoRoutes,
  ...GpaoTacheRoutes,
  ...ConfigurationRoutes,
  ...CrmRoutes,
  ...AgendaRoutes,
  ...RhRoutes,
  ...CompteRoutes,
];

const router = new VueRouter({
  mode: 'history',
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
});

router.beforeEach((routeTo, routeFrom, next) => {
  if (routeTo.matched.some((record) => record.meta.auth)) {
    //page qui necessité d'être connecté
    if (!store.getters['auth/authenticated']) {
      //redirection sur login s'il n'est pas connecté
      next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
    } else {
      next();
    }
  } else {
    next();
  }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  if (routeTo.name) {
    // Start the route progress bar.
    NProgress.start();
  }
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              // Complete the redirect.
              next(...args);
              reject(new Error('Redirected'));
            } else {
              resolve();
            }
          });
        } else {
          // Otherwise, continue resolving the route.
          resolve();
        }
      });
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return;
  }

  // If we reach this point, continue resolving the route.
  next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  // Remove initial loading
  const preLoading = document.getElementById('lds-ripple');
  if (preLoading) {
    preLoading.style.display = 'none';
  }
  setTimeout(() => NProgress.done(), 500);
});

export default router;
